// extracted by mini-css-extract-plugin
export default {"Templates":"ContractTemplates_Templates__uNN4O","TemplateList":"ContractTemplates_TemplateList__dso3K"};